import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import './SummarizeDisconnectPage'
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import { goToPage, stepParams, validateMailHandler , changeMailHandler, setTimeDisconnectOccurred, disconnectProduct } from '../../../DisconnectServiceSlice'
import { Container, Row, Col } from 'reactstrap';
import PopUp from '../../../../../Shared/Popup/PopUp'
import TextInput from '../../../../../Shared/TextInput/TextInput';
import { showAppLoader, hideAppLoader } from '../../../../../Shared/Loader/LoaderSlice';
import { PopUpContent } from '../../DisconnectCommonParts/PopUpAction'
import gaParams from '../../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../../utilities/analytics/tracking';
import Dates from '../../DisconnectCommonParts/datesToDisconnect'
import { isBrowser, isMobile } from "react-device-detect";
import useExtendedEffect from '../../../../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../../../../utilities/hooks/useClearStateResetFlag';


function SummarizeDisconnectPage(props) {
    
    const valid = props.mailForm.emailForm.valid;
    const [isShow, setIsShow] = useState(false);
    const [clicked, SetClicked] = useState(false);
    const [active, setActive] = useState(true);
    const d = Dates(1); 

    let today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    const yyyy = today.getFullYear();
    today = dd + '.' + mm + '.' + yyyy;
    

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_SUMMARY_DISCONNECT_PAGE_CELLULAR.category, gaParams.DISCONNECT_ENTER_SUMMARY_DISCONNECT_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_ENTER_SUMMARY_DISCONNECT_PAGE_CELLULAR.eventParams)
      }, [])

      useEffect(() => {
        if(props.mailForm.emailForm.email != '') {
            props.validateMailHandler(props.mailForm.emailForm);
            if(valid) {
                setActive(true);
            }
            if(props.emailInStore.email && props.emailInStore.email != "" && props.emailInStore.errors.email != "") {
                setActive(false);
            }
        }
    }, [valid, clicked, props.emailInStore.errors.email])

    useEffect(() => {
        if(props.finalDisconnectResponse === true) {
            props.goToPage({ page: 'SUCCESS_MOBILE_DISCONNECT', params: { ...stepParams, hideHeader: true } })
        }
        else if(props.finalDisconnectResponse === false) {
            props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: true } })
        }
    },[props.finalDisconnectResponse])

    // useExtendedEffect((runSideEffects) => {
    //     if (runSideEffects()) {
    //         if(props.finalDisconnectResponse === true) {
    //             props.goToPage({ page: 'SUCCESS_MOBILE_DISCONNECT', params: { ...stepParams, hideHeader: true } })
    //         }
    //         else if(props.finalDisconnectResponse === false) {
    //             props.goToPage({ page: 'UNSUCCESSFUL_MOBILE_DISCONNECT', params: { ...stepParams, hideHeader: true } })
    //         }
    //     }
    // }, [props.finalDisconnectResponse]);

    function closePopUp() {
        gaEvent(gaParams.DISCONNECT_CLICK_THINK_ABOUT_IT_IN_POPUP_CELLULAR.category, gaParams.DISCONNECT_CLICK_THINK_ABOUT_IT_IN_POPUP_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_THINK_ABOUT_IT_IN_POPUP_CELLULAR.eventParams)
        setIsShow(false);
    }

    async function redirectTo() {
        gaEvent(gaParams.DISCONNECT_CLICK_DISCONNECT_ME_IN_POPUP_CELLULAR.category, gaParams.DISCONNECT_CLICK_DISCONNECT_ME_IN_POPUP_CELLULAR.eventType, gaParams.DISCONNECT_CLICK_DISCONNECT_ME_IN_POPUP_CELLULAR.eventParams);
        const data = {
            ProductId: props.serviceToDisconnect.productId,
            Round: null,
            Lfdat: null,
            WaitTo: null,
            WaitFrom: null,
            PickLocation: null,
            DisconnectReasons: props.summarizeUserDisconnectDetails.disconnectReasons.join(", "),
            DisconnectReference: props.writtenProofNumber,
            DisconnectDate: props.summarizeUserDisconnectDetails.timeDisconnectScheduled,
            HasDelivery: false,
            ShippingCost: null,
            Street: null,
            City: null,
            HouseNum: null,
            AptNum: null,
            PhoneNumber: props.serviceToDisconnect.subscriberNumber,
            Email: (props.summarizeUserDisconnectDetails.emailForm.email != "" ? props.summarizeUserDisconnectDetails.emailForm.email : null),
            NotesForDelivery: null
        }
        await props.disconnectProduct(data);
    }

    function next() {
        props.emailInStore.email && props.emailInStore.email !== "" ? gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_CONTINUE_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR.eventType, true) : gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR.category, gaParams.DISCONNECT_CLICK_CONTINUE_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR.eventType, false);
        if(props.emailInStore.email && props.emailInStore.email != "" && props.emailInStore.errors.email != "") {
            setActive(false);
            return;
        }
        SetClicked(true);
        setIsShow(true);
        gaEvent(gaParams.DISCONNECT_VIEW_ARE_YOU_SURE_POPUP_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR.category, gaParams.DISCONNECT_VIEW_ARE_YOU_SURE_POPUP_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR.eventType, gaParams.DISCONNECT_VIEW_ARE_YOU_SURE_POPUP_IN_SUMMARY_DISCONNECT_PAGE_CELLULAR.eventParams)
    }

    return (
        <Container className="SummarizeDisconnectPage-root">
            <Row className="header-row">
                <h3 className="header">שלב הסיכומים ואישור הניתוק</h3>
            </Row>
            {isBrowser ? 
            <Row className="user-details-row">
                <Col>
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
                <Col>
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col>
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
            </Row>
            :
            <>
            <Row className="user-details-row">
                <Col className="pl-1 pr-1">
                    <div className="detail"><span className="txt">שם לקוח: </span>{props.UserInfo.firstName} {props.UserInfo.lastName}</div>
                </Col> 
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">תאריך: </span>{today}</div>
                </Col>
                
            </Row>
            <Row className="user-details-row-second">
                <Col className="pl-0 pr-0">
                    <div className="detail"><span className="txt">ת.ז: </span>{props.UserInfo.IDNumber}</div>
                </Col>
            </Row>
            </>
            }
            <Row className="summarize-details-block">
                <div className="details">
                    <div style={{fontSize: '0.938rem'}}><strong>ניתוק {props.serviceToDisconnect.title} {props.serviceToDisconnect.subscriberNumber}</strong></div>
                    <div style={{fontSize: '0.813rem'}}>{props.serviceToDisconnect.email}</div>
                    <div style={{fontSize: '0.813rem'}}>מספר הלקוח: {props.serviceToDisconnect.customerId}</div>
                    <div style={{fontSize: '0.813rem'}}>בכתובת: {props.serviceToDisconnect.address}</div>
                    <div style={{fontSize: '0.938rem'}} className="section"><strong>הניתוק ייכנס לתוקף</strong></div>
                    {props.dateChanged ? <div style={{fontSize: '0.813rem'}}>{props.summarizeUserDisconnectDetails.timeDisconnectScheduled}</div> : <div style={{fontSize: '0.813rem'}}>{d.options[0].date}</div>}
                </div>
            </Row>
            <Row className="sms-row">
                {/* <div>הסיכום יישלח לך בsms - לטלפון {props.UserInfo.contactNumber} </div> */}
            </Row>
            {props.finalDisconnectResponse === true ? null :
            <Row className="mail-input-row">
                <span style={{fontSize: '0.938rem'}} className="txt">ואפשר גם לקבל את הסיכום למייל:</span>           
                <TextInput onChange={(e) => props.changeMailHandler({target: e.target, form: props.mailForm.emailForm})} id="mail-to" name="email" type="text" placeholder="כתובת מייל" /*required="required"*/ error={props.mailForm.emailForm.errors.email}/>
            </Row>
            }
            {props.finalDisconnectResponse === true && props.emailInStore.valid == "" && props.emailInStore.email !== "" ? 
                <div style={{fontSize: '0.813rem'}} className="mail-msg">נשלח את הפרטים למייל שהזנת</div> : null
            }
            <div className={`btn-container${active ? ' Active' : ''}`}><BtnSubmit text="אישור וסיום" onclick={() => next()}/></div>
            <PopUp showPopUp={isShow} onClose={closePopUp} className="yourClassName">
                <PopUpContent redirectTo={redirectTo} closePopUp={closePopUp}/>
            </PopUp>
        </Container>
    )
}


const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    summarizeUserDisconnectDetails: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    UserInfo: state.authentication.loginData.userDetails,
    mailForm: state.disconnectServicesBlock.summarizeUserDisconnectDetails,
    finalDisconnectResponse: state.disconnectServicesBlock.finalDisconnectResponse,
    loaderError: state.disconnectServicesBlock.loaderError,
    writtenProofNumber: state.disconnectServicesBlock.writtenProofNumber,
    emailInStore: state.disconnectServicesBlock.summarizeUserDisconnectDetails.emailForm,
    dateChanged: state.disconnectServicesBlock.changedDateOfDisconnect
  });
  
  const mapDispatchToProps = {
    goToPage,
    setTimeDisconnectOccurred,
    validateMailHandler, 
    changeMailHandler,
    disconnectProduct,
    showAppLoader,
    hideAppLoader
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(SummarizeDisconnectPage);